/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // console.log('cart update');
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  // console.log('test cart');
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
        // console.log(line_item);
        var userDeviceWidth = $(window).width();
        jQuery('body').addClass('show-preview cart-item-added');
        jQuery('.overlay').removeClass('is-hidden');
        if ( userDeviceWidth > 1024 ) {
          setTimeout(function() {
            if ( $('.cart-preview').hasClass('mouseover') ) {
            } else {
              jQuery('body').removeClass('show-preview cart-item-added');
              jQuery('.overlay').addClass('is-hidden');
            }
          }, 4000);
        }
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

  function removeItemsMini() {
    jQuery('.removeLink').on('click',function(){
      // console.log('remove');
      // console.log( jQuery(this).data('id') );

      var itemNumber = jQuery(this).data('id');
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'updates['+jQuery(this).data('id') +']=0',
        dataType: 'json',
        success: function(cart) {
          // console.log(cart);
          // console.log(cart.total_price);
          // console.log(cart.items.variant_id);

          // var itemNumber = cart.items.variant_id;
          var rowClass = '.item-' + itemNumber;
          // console.log(rowClass);
          var totalPrice = ( cart.total_price / 100 ).toFixed(2);

          if( cart.item_count === 0 ){
            $('#CartCount').html(cart.item_count);
            var output = '';
            output += '<div class="cart-preview__products cart-preview__cart-empty"><p class="cart-empty">Your cart is currently empty.</p></div>';
            $('.cart-preview__ajax').html(output);
          } else {
            $(rowClass).remove();
            $('#CartCount').html(cart.item_count);
            $('.id-cart-count').html(cart.item_count);
            $('#CartCost').html('$' + totalPrice);
          }

            

        },
        error: function(XMLHttpRequest, textStatus) {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(params);
    });
  }
  removeItemsMini();

  $(document).ajaxComplete(function(event, xhr, settings) {
    removeItemsMini();
  });

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/

// Quick add
if( jQuery('.product-size-input' ) ) {
  jQuery(document).on('click', '.product-size-input', function(event) {
    // console.log('quick add');
    event.preventDefault();
    var productId = '.' + jQuery(this).data('id');
    var submitButton = jQuery(productId);
    submitButton.click();
  });
}

var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, updateCartItems, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"],button[type="submit"',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true,
      freeProductEnabled : false,
      freeProductID      : null
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {

    // console.log('updateCountPrice');
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      // console.log(cart.item_count);

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }

  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
          $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>');
      }
    }
  };

  updateCartItems = function (cart) {
    /**** START FREE GIFT AT CHECKOUT ****/
    // If free gift enabled
    if(false == true) {
      var cartItems = cart.items,
          qtyInTheCart = 0,
          cartUpdates = {};

      // loop through each cart item
      for(var i = 0; i < cartItems.length; i++) {
        // if the cart item matches the free product variant id
        if(cartItems[i].id === 32744411070561) {
          // get qty of free product in cart
          qtyInTheCart = cartItems[i].quantity;
          break;
        }
      }

      if((cartItems.length === 1) && (qtyInTheCart > 0)) {
        // if cart is empty except for free product, remove free product
        cartUpdates = { 32744411070561: 0 }
      } else if((cartItems.length >= 1) && (qtyInTheCart !== 1)) {
        // else if cart has products and free product doesn't exist, add it

        // but first, check if we're dealing with price threshold
        if(false == true) {
          if(cart.total_price >= 300 * 100) {
            cartUpdates = { 32744411070561: 1 }
          }
        } else {
          cartUpdates = { 32744411070561: 1 }
        }
      } else {
        if(false == true) {
          if(( cartItems.length === 0 ) && ( cart.total_price < 300 * 100) ) {
            cartUpdates = { 32744411070561: 0 }
          }
        }
      }

      // update
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: cartUpdates },
        dataType: 'json'
      };
      $.ajax(params);
    }
    /**** END FREE GIFT AT CHECKOUT ****/


    var output = '';
    //console.log(cart.items);
    var cartPreviewGrid = $('.cart-preview__ajax');
    $('.cart-preview__ajax').innerHTML = '';
    // cartPreviewGrid.innerHTML = "";
      output += '<div class="cart-preview__products">';
    $.each(cart.items, function(key, val) {
      console.log(val);
      var price = val.price;
      var displayPrice = ( price / 100 ).toFixed(2);
      var itemIndex = cart.items.indexOf(val) + 1;

      var prodTitle = val.title.split(' - ')[0];

      output += '<div class="grid flex-grid cart-preview__row item-' + val.variant_id + '"><div class="grid__item one-half">';
      output += '<a href="' + val.url + '" class="cart__image">';
      output += '<img src="' + val.image + '" alt="' + val.title + '">';
      output += '</a></div><div class="grid__item one-half">';
      output += '<a class="tt-upper" href="' + val.url + '">' + prodTitle + '</a><br><div>';
      if(val.product_type !== 'GIFT CARD') {
        if(val.variant_options[0] !== undefined) {
          output += '<span class="tt-upper">' + val.variant_options[0] + '</span><br>';
        }
        if(val.variant_options[1] !== undefined) {
          output += '<span class="tt-upper">' + val.variant_options[1] + '</span><br>';
        }
      }
      // if(val.product_type !== 'GIFT CARD' && val.product_type !== 'ACCESSORIES' && val.product_type !== 'UNISEX') {
      //   output += '<span class="tt-upper">' + val.properties.Type + '</span>';
      // }
      output += '</div>' + val.quantity + ' x ' + Shopify.formatMoney(val.price, settings.moneyFormat) + ' ' + cart.currency;
      output += '<span class="removeLink cart__remove" data-id="' + val.variant_id + '">Remove</span>';
      output += '</div></div>';

      // cartPreviewGrid.append(gridItem);
    });
    // $(cartPreviewGrid).html(output);
      output += '</div><div class="cart-preview__totals"><h3>TOTAL</h3><div class="grid"><div class="grid__item one-half">';
      output += '<span class="id-cart-count">' + cart.item_count  + '</span> ITEM(S)';
      output += '</div><div class="grid__item one-half">';
      output += '<span id="CartCost">' + Shopify.formatMoney(cart.total_price, settings.moneyFormat) + '</span>' + ' ' + cart.currency;
      output += '</div></div><div class="grid"><div class="grid__item one-half"><a href="/cart" data-item-num="' + cart.item_count  + '">';
      output += '<button class="">View Cart</button></a></div><div class="grid__item one-half">';
      output += '<input type="submit" name="checkout" class="btn--submit-style btn--secondary-check" value="Checkout">';
      output += '</div></div></div>';
    $('.cart-preview__ajax').html(output);
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    /*#85: comment out ajax cart*/
    // console.log(cart.items);
    updateCartItems(cart);
    // buildCart(cart);
  };

  buildCart = function (cart) {
    // console.log('build cart');
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p class="ajaxcart__empty-msg ls100">' + "商品はございません" + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      // console.log('test');

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_large$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalPrice: Shopify.formatMoney((cartItem.line_price + cartItem.total_discount), settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === (cartItem.line_price - cartItem.total_discount) ? false : true
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "Translation missing: ja.cart.general.savings_html".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {

    /**** START FREE GIFT AT CHECKOUT ****/
    if(false == true) {
      var cartItems = cart.items,
          qtyInTheCart = 0,
          cartUpdates = {};

      for(var i=0; i<cartItems.length; i++) {
        if(cartItems[i].id === 32744411070561) {
          qtyInTheCart = cartItems[i].quantity;
          break;
        }
      }

      if((cartItems.length === 1) && (qtyInTheCart > 0)) {
        // if cart is empty except for free product, remove free product
        cartUpdates = { 32744411070561: 0 }
      } else if((cartItems.length >= 1) && (qtyInTheCart !== 1)) {
        // else if cart has products and free product doesn't exist, add it

        // but first, check if we're dealing with price threshold
        if(false == true) {
          if(cart.total_price >= 300 * 100) {
            cartUpdates = { 32744411070561: 1 }
          }
        } else {
          cartUpdates = { 32744411070561: 1 }
        }
      } else {
        if(false == true) {
          if(( cartItems.length === 0 ) && ( cart.total_price < 300 * 100) ) {
            cartUpdates = { 32744411070561: 0 }
          }
        }
      }

      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: cartUpdates },
        dataType: 'json'
      };
      $.ajax(params);
    }
    /**** END FREE GIFT AT CHECKOUT ****/

    // console.log('cartCallback');
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
  };

  adjustCart = function () {
    // console.log('adjustCart');
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--remove')) {
          qty = 0;
      } else if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {

      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // console.log('adjustCartCallback');
    // Update quantity and price
    updateCountPrice(cart);

    /*#85: comment out ajax cart*/
    // Reprint cart on short timeout so you don't see the content being removed
    // setTimeout(function() {
    //   isUpdating = false;
    //   ShopifyAPI.getCart(buildCart);
    // }, 150)
  };

  createQtySelectors = function() {
    // console.log('createQtySelectors');
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // console.log('qtySelectors');
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function(cart) {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);

        $( "input[name='checkout']").attr('disabled','disabled');
        $( "input[name='update']" ).trigger( "click" );
      });
    }
  };

  validateQty = function (qty) {
    // console.log('validateQty');
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
